module.exports = __webpack_public_path__ + "img/close_icon.1e18fb46.svg";